import { FeedItemResponse } from "@every.org/common/src/codecs/entities";
import { getTagRouteSpec } from "@every.org/common/src/routes/publicCached";
import { getTagNonprofitsFeedRouteSpec } from "@every.org/common/src/routes/tag";

import { InitialContextData } from "src/context/ContextProviders";
import { PageNum } from "src/context/DonationsContext/actions";
import { serversideStaticQueryApi } from "src/utility/apiClient";

export async function getCauseProps(tagName: string): Promise<{
  initialData?: InitialContextData;
  feedItems: FeedItemResponse[];
  isCausePage: boolean;
}> {
  const tagRouteSpecPromise = serversideStaticQueryApi(getTagRouteSpec, {
    routeTokens: { identifier: tagName },
    queryParams: {},
  });

  // Needed to keep TS happy. TODO: a better way because getTagNonprofitsFeedRouteSpec.authenticated is never true
  if (getTagNonprofitsFeedRouteSpec.authenticated === true) {
    throw new Error("this never happens but keeps TS happy");
  }

  const tagNonprofitFeedPromise = serversideStaticQueryApi(
    getTagNonprofitsFeedRouteSpec,
    {
      routeTokens: { tagName: tagName },
      queryParams: { pageNum: 0 as PageNum },
    }
  );

  const [tagResponse, tagNonprofitFeedResponse] = await Promise.all([
    tagRouteSpecPromise,
    tagNonprofitFeedPromise,
  ]);

  return {
    initialData: {
      tags: [tagResponse.tag],
      nonprofits: tagNonprofitFeedResponse.nonprofits,
    },
    feedItems: tagNonprofitFeedResponse.items,
    isCausePage: true,
  };
}
